import MuiCard from '@mui/material/Card'
import MuiCardHeader from '@mui/material/CardHeader'

const PageTitle = ({ title, action }) => (
  <MuiCard square variant="pageTitle">
    <MuiCardHeader title={title} action={action} />
  </MuiCard>
)

export default PageTitle
